import React from 'react'
// import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import Tip from '@/components/common/Tip'
import black from '@/assets/images/bottom-black@3x.png'

// Lib MISC
import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

export const propTypes = {}

function Contact ({ lang }) {
  const $t = words[lang]

  return (
    <div className={cx('contact')}>
      <Tip className={cx('contact-tip')} tipClassName={cx('contact-tip-item')} img={black} />
      <div className={cx('contact-wrap')}>
        <p className={cx('contact-wrap-header')}>{$t.TXT_Contact_title}</p>
        <div className={cx('contact-wrap-content')}>
          <p className={cx('contact-wrap-content-title')}>{$t.TXT_Contact_email_title}</p>
          <a className={cx('contact-wrap-content-text')} href={`mailto:${$t.TXT_Contact_email_context}`}>{$t.TXT_Contact_email_context}</a>
        </div>
        <div className={cx('contact-wrap-content')}>
          <p className={cx('contact-wrap-content-title')}>{$t.TXT_Contact_address_title}</p>
          <p className={cx('contact-wrap-content-text')}>{$t.TXT_Contact_address_context1}</p>
          <p className={cx('contact-wrap-content-text')}>{$t.TXT_Contact_address_context2}</p>
          <p className={cx('contact-wrap-content-text')}>{$t.TXT_Contact_address_context3}</p>
        </div>
      </div>
    </div>
  )
}

Contact.propTypes = propTypes

export default Contact
